<template>
  <div class="messages__chat_list_search">
    <div class="messages__chat_list_search__icon">
      <ChatListSearchIcon />
    </div>
    <div class="messages__chat_list_search__field">
      <label for="chat_list_search_input" class="sr_only">{{ inputLabel }}</label>
      <input id="chat_list_search_input" type="text" :placeholder="inputLabel" :value="searchQuery" @input="onInput" />
    </div>
  </div>
</template>

<script>
import ChatListSearchIcon from './ChatListSearchIcon.vue'

export default {
  name: 'ChatListSearch',
  components: { ChatListSearchIcon },
  props: {
    // chatScope has to be passed as a prop to this component
    // so that in beforeUnmount, we can still perform a search for the old chatScope
    // (this.$route.params.chatScope will have the updated value already)
    chatScope: {
      type: String,
      required: true
    },
    searchQuery: {
      type: String,
      required: true
    },
    search: {
      type: Function,
      required: true
    }
  },
  computed: {
    inputLabel() {
      return this.i18n.$gettext('Search members')
    }
  },
  beforeUnmount() {
    // if currently showing search results, reset them between switching chat scopes
    if (this.searchQuery !== '') {
      this.search(this.chatScope, '')
    }
  },
  methods: {
    onInput(e) {
      this.search(this.chatScope, e.target.value)
    }
  }
}
</script>
